<script setup>
import { reactiveOmit } from "@vueuse/core";
import { Label as LabelPrimitive } from "reka-ui";
import { cn } from "@/shared/lib/utils";

const props = defineProps({
  class: { type: [String, Object, Array], default: undefined },
  for: { type: String, default: undefined },
});

const delegatedProps = reactiveOmit(props, "class");
</script>

<template>
  <LabelPrimitive
    data-slot="label"
    v-bind="delegatedProps"
    :class="
      cn(
        'flex items-center gap-2 text-sm leading-none font-medium select-none group-data-[disabled=true]:pointer-events-none group-data-[disabled=true]:opacity-50 peer-disabled:cursor-not-allowed peer-disabled:opacity-50',
        props.class
      )
    "
  >
    <slot />
  </LabelPrimitive>
</template>
